import React, { Component } from "react";
import Modal from "../../Modal/modal";

class TeaserGridVideo extends Component {
    constructor(props) {
        super(props);
    }

    getEmbeddedUrl(refUrl) {
        if (!refUrl || refUrl.length <= 0) {
            return "";
        }

        const regex = /(.*?)\/secret\/([0-9]+)\/(.*$)/gm;
        const match = regex.exec(refUrl);

        const baseUrl = match[1],
            photoId = match[2],
            videoId = match[3];

        return `${baseUrl}/v.ihtml/player.html?token=${videoId}&photo_id=${photoId}`;
    }

    render() {
        const baseClass = "teaser-grid-video";

        return (
            <Modal
                toClose={() => {
                    this.props.setVideoModal(false, "");
                }}
                isOpen={this.props.videoModalActive}
                showCloseButton
                size="auto"
            >
                <div
                    className={`${baseClass}__modal-content`}
                    style={{
                        margin: "auto"
                    }}
                >
                    <div className={`${baseClass}__video-wrapper`}>
                        <iframe
                            title={this.props.title}
                            src={this.getEmbeddedUrl(this.props.VideoUrl)}
                            allow="fullscreen"
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default TeaserGridVideo;
